var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 27.3333C7.30555 27.3333 5.14583 26.4583 3.35416 24.7083C1.5625 22.9583 0.666664 20.8194 0.666664 18.2916C0.666664 16.125 1.31944 14.1944 2.625 12.5C3.93055 10.8055 5.63889 9.72218 7.75 9.24996C8.44444 6.6944 9.83333 4.62496 11.9167 3.04163C14 1.45829 16.3611 0.666626 19 0.666626C22.25 0.666626 25.0069 1.79857 27.2708 4.06246C29.5347 6.32635 30.6667 9.08329 30.6667 12.3333C32.5833 12.5555 34.1736 13.3819 35.4375 14.8125C36.7014 16.243 37.3333 17.9166 37.3333 19.8333C37.3333 21.9166 36.6042 23.6875 35.1458 25.1458C33.6875 26.6041 31.9167 27.3333 29.8333 27.3333H9.83333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherCloud);
export default __webpack_public_path__ + "static/media/weather-cloud.5b8ef55b688364b28ccd876f1bd0f53f.svg";
export { ForwardRef as ReactComponent };